/* One row of the versions timeline (`.ver-list` in the mockup), moved from the chip's sheet (mockup v3). */
.row {
  position: relative;
  display: grid;
  grid-template-columns: 40px 1fr;
  gap: var(--space-2);
  padding: var(--space-2);
  border-radius: var(--radius-control);
}

.row:hover {
  background: var(--surface-sunken);
}

/* The version the canvas shows: a neutral tint, so the info badge (--action-soft) stays visible on it. */
.row[data-shown="true"] {
  background: var(--state-active);
}

/* On the tint the date steps up to the muted text: --text-subtle there is 4.48:1 in dark (D-UX-48). */
.row[data-shown="true"] .what {
  color: var(--text-muted);
}

/* The timeline's line between one version and the next. */
.row::before {
  content: "";
  position: absolute;
  inset-block: 30px -8px;
  inset-inline-start: 19px;
  inline-size: 1px;
  background: var(--border);
}

.row:last-child::before {
  display: none;
}

.name {
  margin: 0;
  padding-block-start: 1px;
  font-size: var(--font-size-13);
  font-weight: var(--font-weight-semibold);
  font-variant-numeric: tabular-nums;
}

.body {
  min-inline-size: 0;
}

.what {
  display: flex;
  align-items: center;
  gap: 6px;
  color: var(--text-subtle);
  font-size: var(--font-size-12);
}

.actions {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-1);
  margin-block-start: 6px;
}
